import { useEffect, useRef } from 'react';
import { message } from 'antd'; // Используем компоненты Ant Design для уведомлений

// Наш файл с версией. Убедитесь, что он доступен по этому URL.
// Если файл лежит в папке 'public', то путь будет '/version.json'.
const VERSION_FILE_URL = '/assets/version.json';
// Интервал проверки в миллисекундах (например, каждые 5 минут)
const CHECK_INTERVAL = 5 * 60 * 1000;

// Функция для получения текущей версии приложения
async function fetchCurrentVersion() {
  try {
    const response = await fetch(VERSION_FILE_URL, { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Не удалось получить файл версии`);
    }
    
    // Проверяем, что ответ действительно JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      console.error('Получен не-JSON ответ:', text.substring(0, 200));
      throw new Error('Сервер вернул не-JSON ответ');
    }
    
    const data = await response.json();
    return data.buildHash;
  } catch (error) {
    console.error('Ошибка при проверке версии:', error);
    return null;
  }
}

// Компонент-обёртка для всего приложения, который будет проверять версию
const VersionChecker = ({ children }) => {
  // useRef используется, чтобы хранить хеш текущей версии без вызова ререндера
  const currentBuildHash = useRef(process.env.REACT_APP_BUILD_HASH || 'dev-build');

  useEffect(() => {
    // В реальном приложении, REACT_APP_BUILD_HASH должен быть установлен во время сборки.
    // Например, с помощью Webpack, Vite или CI/CD
    // Для примера, мы просто установим его
    //currentBuildHash.current = 'a1b2c3d4e5f6g7h8i9j0'; // Пример статической версии

    const checkVersion = async () => {
      console.log('Проверка версии...', { currentHash: currentBuildHash.current, url: VERSION_FILE_URL });
      const latestBuildHash = await fetchCurrentVersion();
      console.log('Получен хеш версии:', latestBuildHash);
      
      // Если хеши не совпадают, это значит, что на сервере есть новая версия
      if (latestBuildHash && latestBuildHash !== currentBuildHash.current) {
        console.log('Найдены обновления. Перезагрузка страницы...');
        // Показываем уведомление перед перезагрузкой
        message.warning('Найдена новая версия. Страница будет перезагружена.', 5);
        
        // Перезагрузка страницы через 5 секунд, чтобы пользователь успел прочитать
        setTimeout(() => {
          window.location.reload(true); // 'true' делает принудительную перезагрузку
        }, 5000);
      } else {
        console.log('Версия актуальна');
      }
    };

    // Запускаем проверку сразу после монтирования компонента
    checkVersion();

    // Затем запускаем периодическую проверку
    const intervalId = setInterval(checkVersion, CHECK_INTERVAL);

    // Очистка интервала при размонтировании компонента
    return () => clearInterval(intervalId);
  }, []); // Пустой массив зависимостей, чтобы useEffect сработал один раз

  return <>{children}</>;
};

export default VersionChecker;
